import React from "react";

const VIEWS = [
  { name: "CutOff", value: "cutoff", icon: "bi bi-calendar-range" },
  { name: "Retained Net Income", value: "retained", icon: "bi bi-graph-up" },
];

// Segmented control rendered inside each view's canvas (below the header)
function CutoffViewSwitch({ view, onChange }) {
  return (
    <div className="w-100 px-4 pt-1 pb-2">
      <div
        className="cutoff-switch d-inline-flex p-1 rounded-3 border"
        role="tablist">
        {VIEWS.map((item) => {
          const isActive = view === item.value;
          return (
            <button
              key={item.value}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`cutoff-switch-btn btn btn-sm border-0 rounded-2 px-3 py-2 d-flex align-items-center ${
                isActive ? "is-active shadow-sm fw-semibold" : "text-muted"
              }`}
              style={{ transition: "all 0.15s ease" }}
              onClick={() => !isActive && onChange(item.value)}>
              <i className={`${item.icon} me-2`}></i>
              {item.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default CutoffViewSwitch;
